//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
export default {
  props: {
    value: {
      default: false
    },
    disabled: {
      default: false
    },
    popoverPlacement: {
      default: 'top'
    },
    popoverTitle: {
      default: '修改'
    },
    popoverWidth: {
      default: '150'
    },
    trigger: {
      default: 'click'
    },
    className: {
      default: ""
    },
    owner: {
      default: () => ({
        loading: false
      })
    }
  },
  data () {
    return {
      currentValue: this.value,
      currentDisabled: this.disabled
    }
  },
  watch: {
    value: {
      handler (val) {
        if (this.currentDisabled) {
          this.currentDisabled = false
        }
        if (this.currentValue !== val) {
          this.currentValue = val
        }
      },
      immediate: true
    },
    currentValue: {
      handler (val) {
        if (this.value !== val) {
          this.$emit('input', val)
        }
      }
    },
    disabled: {
      handler (val) {
        this.currentDisabled = val
      },
      immediate: true
    }
  },
  methods: {
  }
}
